/*
  Product card "Add to cart" feedback: after a confirmed add from a product card's
  full-width button, show "Added ✓" (solid button) for a moment, then restore it.
  Only reacts when the theme reports the same variant as added (DeliEvents cartUpdate),
  so it never claims success for a failed add. Variant products open quick add instead.
*/
(() => {
  if (window.__mProductCardAddFeedback) return;
  window.__mProductCardAddFeedback = true;

  const ADDED_TEXT = 'Added ✓';
  const DURATION = 2000;
  let pending = null;

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(
        '.m-product-card__add .m-button--icon, .m-product-card__hover-add .m-button--icon'
      );
      if (!button) return;
      const form = button.closest('form');
      const input = form && form.querySelector('input[name="id"]');
      if (!input) return;
      pending = { button, variantId: String(input.value), time: Date.now() };
    },
    true
  );

  const showAdded = (event) => {
    if (!pending || Date.now() - pending.time > 10000) return;
    if (event && event.productVariantId && String(event.productVariantId) !== pending.variantId) return;

    const { button } = pending;
    pending = null;
    const label = button.querySelector('.m-tooltip-label');
    if (!label) return;

    const original = label.dataset.originalText || label.textContent;
    label.dataset.originalText = original;
    label.textContent = ADDED_TEXT;
    button.classList.add('is-added');

    clearTimeout(button._mAddedTimer);
    button._mAddedTimer = setTimeout(() => {
      label.textContent = original;
      button.classList.remove('is-added');
    }, DURATION);
  };

  const subscribe = () => {
    if (window.DeliEvents && window.DeliTheme && DeliTheme.pubSubEvents) {
      DeliEvents.subscribe(DeliTheme.pubSubEvents.cartUpdate, (event) => {
        if (!event || !event.cart || event.cart.errors) return;
        showAdded(event);
      });
    } else {
      document.addEventListener('product-ajax:added', () => showAdded(null));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', subscribe);
  } else {
    subscribe();
  }
})();
